export default function isGTIN(gtin) {
  // Remove any non-numeric characters
  // const sanitizedGTIN = gtin.replace(/\D/g, '')

  const sanitizedGTIN = gtin

  // GTIN must be 8, 12, 13, or 14 digits
  const validLengths = [8, 12, 13, 14]
  if (!validLengths.includes(sanitizedGTIN.length)) {
    return false
  }

  // Checksum validation (Mod 10 algorithm)
  const checkSum = (digits) => {
    let sum = 0
    for (let i = 0; i < digits.length; i++) {
      let digit = parseInt(digits[digits.length - i - 1], 10)
      if (i % 2 === 0) {
        digit *= 3
      }
      sum += digit
    }
    return sum % 10 === 0
  }

  return checkSum(sanitizedGTIN)
}
